
import StudioToolbar from "./StudioToolbar";
import StudioSidebar from "./StudioSidebar";
import StudioCanvas from "./StudioCanvas";
import StudioProperties from "./StudioProperties";
import StudioFooter from "./StudioFooter";

export default function Studio() {
  return (
    <section className="min-h-screen bg-[#0b111c]">

      <div className="mx-auto max-w-[1900px] p-3 sm:p-6">

        {/* Toolbar */}

        <StudioToolbar />

        {/* Workspace — stacks on mobile, 3 columns on large screens */}

        <div className="mt-4 sm:mt-6 grid grid-cols-1 gap-4 sm:gap-6 items-start lg:grid-cols-[220px_minmax(0,1fr)_260px]">

          {/* Left */}

          <div className="min-w-0 lg:w-[220px]">
            <StudioSidebar />
          </div>

          {/* Canvas */}

          <div className="min-w-0">
            <StudioCanvas />
          </div>

          {/* Right */}

          <div className="min-w-0 lg:w-[260px]">
            <StudioProperties />
          </div>

        </div>

        {/* Footer */}

        <div className="mt-4 sm:mt-6">
          <StudioFooter />
        </div>

      </div>

    </section>
  );
}